// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status {
  text-transform: uppercase;
  color: #fff;
}
.status.status-1 {
  background-color: var(--successColour);
}
.status.status-2, .status.status-4 {
  background-color: var(--warningColour);
}
.status.status-3, .status.status-5 {
  background-color: var(--dangerColour);
}

.role {
  font-size: 0.6rem;
  background-color: #ddd;
  font-weight: 600;
  padding: 3px 5px;
  border-radius: 5px;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/site-admin/site-admin-search.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,WAAA;AACF;AACE;EACE,sCAAA;AACJ;AAEE;EACE,sCAAA;AAAJ;AAGE;EACE,qCAAA;AADJ;;AAKA;EACE,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAFF","sourcesContent":[".status {\n  text-transform: uppercase;\n  color: #fff;\n\n  &.status-1 {\n    background-color: var(--successColour);\n  }\n\n  &.status-2, &.status-4 {\n    background-color: var(--warningColour);\n  }\n\n  &.status-3, &.status-5 {\n    background-color: var(--dangerColour);\n  }\n}\n\n.role {\n  font-size: 0.6rem;\n  background-color: #ddd;\n  font-weight: 600;\n  padding: 3px 5px;\n  border-radius: 5px;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
